import IconAction from './IconAction';

const InTableViewAction = (props) => {
    return <IconAction {...props} size="small" />;
};

export default InTableViewAction;
